import { Component, OnInit } from '@angular/core';
import { E5coreUiCategorizationBase } from './e5core-ui-categorization-base';

@Component({
    selector: 'e5core-ui-categorization-material',
    templateUrl: './e5core-ui-categorization-material.component.html',
    styleUrls: ['./e5core-ui-categorization-material.component.css']
})
export class E5coreUiCategorizationMaterialComponent extends E5coreUiCategorizationBase implements OnInit {

    constructor() {
        super() ;
    }

    ngOnInit() {
        this.cat1List.find(i => i.id === this.categorization[0]) ;
    }

}
